type TabKey = 'pending_reception' | 'in_progress' | 'collaboration' | 'completed' | 'obstacle';

/**
 *    TICKET SOCKET
 *
 * # NOTIFICATION_TYPE THEO TICKET STATUS ==
 * CHO-TIEP-NHAN ==> [ 6, 13 ] ==> pending_reception
 *    TICKET_RECEIVED
 *    TICKET_CREATED_PENDING_RECEPTION
 *
 * DANG-XU-LY ==> [ 14, 13, 12, 11 ] ==> in_progress
 *    TICKET_RETURN_TTCSKH
 *    TICKET_RECEIVED
 *    TICKET_UPDATED
 *    TICKET_CLOSED
 *
 * HOAN-TAT ==> [ 11 ] ==> completed
 *    TICKET_CLOSED
 *
 * PHOI-HOP [ 9, 10 ] ==> collaboration
 *    TICKET_COLLABORATION_SENT
 *    TICKET_COLLABORATION_CLOSED
 *
 * PHOI-HOP-HOAN-TAT [ 9, 11 ] ==> collaboration
 *    TICKET_CLOSED
 *    TICKET_COLLABORATION_CLOSED
 *
 * TRO-NGAI [ 8, 11 ] ==> obstacle
 *    TICKET_CLOSED
 *    TICKET_HOLD_MANAGER
 * */

export const getTabsByNotificationType = (type: number): TabKey[] => {
  const mapping: Record<number, TabKey[]> = {
    6: ['pending_reception'], // Tạo phiếu mới
    13: ['pending_reception', 'in_progress'], //  nhận phiếu

    14: ['in_progress'],  //  Chuyển phiếu về TTCSKH
    12: ['in_progress'],  //  Cập nhật phiếu yêu cầu
    11: ['in_progress', 'completed', 'collaboration', 'obstacle'], // Đóng phiếu / hoàn tất phiếu

    9: ['collaboration', 'obstacle'], //  ĐÓNG - Phối hợp xử lý
    10: ['collaboration'],  //  GỬI - Phối hợp xử lý

    8: ['obstacle'], //  Ticket hold manager ==> phiếu trở ngại

    16: ['pending_reception', 'in_progress', 'collaboration', 'obstacle'] //  Chuyển đơn vị xử lý
  };
  return mapping[type] || [];
};